import { BooleanField, Datagrid, Loading, RaRecord, TextField, useListContext, useTranslate } from "react-admin";
import { Sector } from "../../../shared/types/types";
import CoreEditButton from "../../../shared/components/core/CoreEditButton";
import CoreDeleteButton from "../../../shared/components/core/CoreDeleteButton";
import sacopModules from "../../../shared/utilities/sacopModules";
import NoDataFound from "../../../shared/components/noDataFound/NoDataFound";

interface MobileGridProps {
    data?: RaRecord[];
    isLoading?: boolean;
}

const MobileGrid = ({ data, isLoading }: MobileGridProps) => {
    const translate = useTranslate();
    if (isLoading || !data || data.length === 0) 
    {
        if (data?.length === 0)
            return <NoDataFound />
        return <Loading />; 
    }
    return (
        <Datagrid bulkActionButtons={false}>
            <TextField source="code" variant="body1" />
            <TextField source="name" variant="body1" />
            <BooleanField source="active" />
            <BooleanField source="operative" />
            
            <CoreEditButton permission="BACKOFFICE_NORMATIVE_U" actionModule={sacopModules.NONE} />
            <CoreDeleteButton permission="BACKOFFICE_NORMATIVE_D" />
        </Datagrid>

    );
};



export default MobileGrid;
